import { action } from '@reatom/framework'

import { reatomBackOfficeWalletsRefreshBalancesRequestAction } from '@root/entities/back-office/atoms/reatom-back-office-wallets-refresh-request-action'
import { reatomRequest } from '@root/shared/lib'

import type { DelugeId } from '@root/entities/user-short'
import type { WalletId } from '@root/entities/wallet'

interface BackOfficeWalletsRefreshBalancePayload {
  wallets: Array<{
    delugeId: DelugeId
    walletId: WalletId
  }>
}

export const reatomBackOfficeWalletsRefreshBalancesModel = (
  data: BackOfficeWalletsRefreshBalancePayload,
) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  return reatomRequest({
    // eslint-disable-next-line @reatom/unit-naming-rule
    execAction: action((ctx) =>
      // eslint-disable-next-line @reatom/unit-naming-rule
      reatomBackOfficeWalletsRefreshBalancesRequestAction(ctx, data),
    ),
  })
}
